export default "__VITE_ASSET__DP4vtHHZ__"